import React, { useState, useEffect, useRef } from "react";

import { useHistory, useRouteMatch, Link, NavLink, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useIntercom } from 'react-use-intercom';

import { OverlayTrigger, Popover, Nav, Dropdown } from "react-bootstrap";

import Truncate from "react-truncate";

import cx from "classnames";
import _ from "lodash";

import { MIXPANEL_PAGE_VIEWED_WORKSPACE_REPORTS, MIXPANEL_PAGE_VIEWED } from "constants/mixpanelEvents";
import { createMixpanelEvent } from "actions/mixpanel";
import { getPageViewedEventPayload } from 'services/mixpanelUtil';
import styles from "./applicationMenu.module.scss";
import userRoleService from "services/userRoles.service";
import { getPrimaryUserRole } from "constants/userRoles";
import { Button } from "react-bootstrap";
import TruncatedTextWithTooltip from "components/TruncatedTextWithTooltip";


const INTERCOM_ID = process.env.REACT_APP_CLEVERSTORY_INTERCOM_ID;

export default function ApplicationMenu(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const locationData = useLocation()
  let { path, url } = useRouteMatch();
  const { boot, show } = useIntercom();

  const profile = useSelector((state) => _.get(state, "users.me", null));
  const workspaces = useSelector((state) => _.get(state, "workspaces.items", null));
  const user = useSelector((state) => _.get(state, "users.me"));
  const userRole = useSelector((state) => _.get(state, "workspaces.workspace.item.userRoles", []));
  const admin = getPrimaryUserRole(userRole)?.key;

  const renderIcon = () => {
    return _.get(profile, "icon.thumbnail", null);
  };

  const renderUserName = () => {
    if (!profile) {
      return false;
    }

    return _.get(profile, 'firstName').concat(" ", _.get(profile, 'lastName'));
  }

  const initializeIntercom = () => {

    boot({
      appID: INTERCOM_ID,
      name: `${user.firstName} || '' ${user.lastName} || ''`,
      userId: `${user.email}`,
      email: `${user.email}`,
      hideDefaultLauncher: true,
    })
  }

  useEffect(() => {
    if (user) {
      initializeIntercom();
    }
  }, [user]);

  const popover = (
    <Popover id="popover-basic" className={styles.tooltip}>
      <div className={styles.userDetails}>
        <img
          className={styles.userIcon}
          src={renderIcon()}
          alt="/images/profile/default_user_profile_background.png"
        />
        <TruncatedTextWithTooltip className={styles.userName} content={renderUserName()} maxWidth={125} placement="bottom" />
      </div>
      <div className={styles.userMenus}>
        <Link className={styles.userMenu} onClick={() => document.body.click()} to={`${url}/settings/user-profile`}>
          User Profile
        </Link>
        <Link className={styles.userMenu} onClick={() => document.body.click()} to={{ pathname: "https://app.paperflite.com/privacy" }} target="_blank">
          Privacy Policy
        </Link>
        <Link className={styles.userMenu} onClick={() => document.body.click()} to={{ pathname: "https://app.paperflite.com/terms/" }} target="_blank">
          Terms &amp; Conditions
        </Link>
      </div>
      <div onClick={(e) => {
        e.preventDefault();
        window.location.href = "/logout";
      }} className={styles.logout}>
        <span>Log Out</span>
      </div>
    </Popover>
  );

  const WorkspaceDropdown = ({ }) => {
    const history = useHistory();

    const activeWorspace = useSelector(state => _.get(state, `workspaces.workspace.item`));

    const handleChange = (workspace) => {
      window.location.replace(`/app/${workspace.id}/storyboards`);
    }

    return (
      <Dropdown className={styles.pageDropDown} >
        <Dropdown.Toggle data-track-event="Mixpanel" data-track-props="Workspace toggle">
          <span className={styles.name}>
            <Truncate lines={1}>
              {_.get(activeWorspace, "name")}
            </Truncate>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {workspaces.map((workspace) => {
            const active = workspace.id === _.get(activeWorspace, 'id');
            return (
              <Dropdown.Item active={active} key={workspace.uid} onClick={() => handleChange(workspace)}>
                <span className={styles.name}>
                  <Truncate lines={1}>
                    {workspace.name}
                  </Truncate>
                </span>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  const checkActive = () => {
    if (!locationData) {
      return false;
    }
    const { pathname } = locationData;
    return _.includes(pathname, 'integration-settings') ? true : false;
  };

  const settingsUrl = () => {
    var settingUrl = `${url}/integration-settings/integration`;

    if (userRoleService.canManageUsers()) {
      settingUrl = `${url}/integration-settings/user-management`;
    }

    return settingUrl;
  }

  const handleReportsClick = () => {
  
    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_WORKSPACE_REPORTS);
    mixPanelPayload = {
      ...mixPanelPayload,
    }
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload));
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.logoContainer}>
          <div className={styles.logo}></div>
        </div>
        <div className={styles.mainMenu}>
          <Nav>
            <NavLink as={Link}
              className={styles.menuItem}
              activeClassName={styles.active} to={`${url}/storyboards`}>Storyboards</NavLink>
          </Nav>
          <Nav>
            <NavLink as={Link}
              className={cx(styles.menuItem, styles.settingButton)}
              activeClassName={styles.active} isActive={checkActive} to={settingsUrl()}>Workspace Settings</NavLink>
          </Nav>

          {admin === "administrator" &&
            <Nav>
                <NavLink as={Link}
                className={cx(styles.menuItem, styles.settingButton)}
                activeClassName={styles.active} to={`${url}/reports`} onClick={handleReportsClick}>Reports</NavLink>
            </Nav>
          }
          
        </div>

        {workspaces.length > 1 &&
          <div className={styles.mainMenu}>
            <WorkspaceDropdown />
          </div>
        }

        <div className={styles.subMenu}>
          <OverlayTrigger
            trigger="click"
            placement="bottom-end"
            rootClose={true}
            overlay={popover}
          >
            <div className={styles.avatar} data-track-event="Mixpanel" data-track-props="Profile Pic">
              <img src={renderIcon()} alt={renderUserName()} />
            </div>
          </OverlayTrigger>
       </div>
       <div className={styles.helpButtonContainer}>
       <Button size='sm' variant='primary' onClick={show} className={styles.helpButton} data-track-event="Mixpanel" data-track-props="Help from home">
          <i className={cx(styles.helpIcon, "cleverstory-support-help")} />
          Help
       </Button>
       </div>
      </div>
    </>
  );
}